import '../styles/main.scss';
import '../styles/search-utils.scss';

import $ from 'jquery';
const jQuery = $;
window.jQuery = jQuery;
require('bootstrap');
import '@bower_components/bootstrap-switch';
import '@bower_components/seiyria-bootstrap-slider';
import ko from '@bower_components/knockout/dist/knockout';
import {Router} from '@bower_components/director/build/director';

import LocationsModel from './search/model.js';

($ => {
  'use strict';

  var embedRedirect;
  try {
    document.domain = 'tcc-chemnitz.de';
    embedRedirect = window.top.flaechenSuchenRedirect ||
      '//flaechen.tcc-chemnitz.de/suchen/#/reactive';
  } catch (e) {
    embedRedirect = '//flaechen.tcc-chemnitz.de/suchen/#/reactive';
  }

  var types = {
    2: 'Büro',
    3: 'Werkstatt',
    5: 'Lager'
  };

  var data;
  var model;
  var container = $('#SliderContainer');
  var resultContainer = $('#ResultContainer');
  var router = new Router().configure({html5history: false});

  $.fn.bootstrapSwitch.defaults.onText = 'Suchen';
  $.fn.bootstrapSwitch.defaults.offText = 'Nicht Suchen';

  /**
   * load the lookup data
   * @param  {string} path lookup url
   */
  function loadJson(path) {
    jQuery.getJSON(path, result => {
      data = result.results;
      container.trigger('lookup-done');
    });
  }

  /**
   * change string to number
   * @param  {string} val obj
   * @return {Number}     new number
   */
  function parseDecimal(val) {
    return parseInt(Number(val).toFixed(), 10);
  }

  /**
   * change number to nice string
   * @param  {Number} val obj
   * @return {string}     new string
   */
  function printDecimal(val) {
    return val + ' m²';
  }

  /**
   * max nums
   * @param  {Number} a first
   * @param  {Number} b second
   * @return {Number}   result
   */
  function max(a, b) {
    if (a > b) {
      return a;
    }
    return b;
  }

  /**
   * render input addons
   * @param  {jQueryElem} elm target
   * @param  {Number} min min
   * @param  {Number} max max
   */
  function renderBounds(elm, min, max) {
    elm.siblings('.input-group-addon:eq(0)').text(printDecimal(min));
    elm.siblings('.input-group-addon:eq(1)').text(printDecimal(max)).text(' ');
  }

  /**
   * load inits from localStorage
   * @return {Object} inits
   */
  function getInitOptions() {
    var inits = {};
    $.each(types, (id, typ) => {
      if (!inits[id]) {
        inits[id] = {};
      }
      var val = parseInt(localStorage.getItem(typ), 10);
      if (isNaN(val)) {
        inits[id].value = undefined;
        inits[id].enabled = (
          localStorage.getItem(typ) === null && (
            id === 2 || id === '2')
        );
      } else {
        inits[id].value = val;
        inits[id].enabled = true;
      }
      localStorage.removeItem(typ);
    });
    return inits;
  }

  loadJson('/free/');

  container.on('lookup-done', () => {
    var offices = $.map(data['2'].areas, parseDecimal);
    var workshops = $.map(data['3'].areas, parseDecimal);
    var storages = $.map(data['5'].areas, parseDecimal);

    // limits and start values
    // office
    var maxoffice = data['2'].sums.map(i => Number(i.area)).reduce(
      max, 0).toFixed();

    // workshop
    var maxworkshops = data['3'].sums.map(i => Number(i.area)).reduce(
      max, 0).toFixed();

    // storages
    var maxstorages = data['5'].sums.map(i => Number(i.area)).reduce(
      max, 0).toFixed();

    // start Values
    var options = getInitOptions();
    var officeValue = options[2].value || maxoffice * 0.15;
    var workshopValue = options[3].value || maxworkshops * 0.5;
    var storageValue = options[5].value || maxstorages * 0.15;

    // init switches
    var officeSwitch = $('[name="officeEnable"]').attr(
      'checked', options[2].enabled)
      .bootstrapSwitch();
    var workshopSwitch = $('[name="workshopEnable"]').attr(
      'checked', options[3].enabled)
      .bootstrapSwitch();
    var storageSwitch = $('[name="storageEnable"]').attr(
      'checked', options[5].enabled)
      .bootstrapSwitch();

    // init sliders
    var officeSlide = $('#office').slider(
      {id: 'slideroffice', min: offices[0], max: maxoffice,
       value: officeValue,
       enabled: officeSwitch.is(':checked'),
       formatter: printDecimal});

    var workshopSlide = $('#workshop').slider(
      {id: 'sliderworkshop', min: workshops[0], max: maxworkshops,
       value: workshopValue,
       enabled: workshopSwitch.is(':checked'),
       formatter: printDecimal});

    var storageSlide = $('#storage').slider(
      {id: 'sliderstorage', min: storages[0], max: maxstorages,
       value: storageValue,
       enabled: storageSwitch.is(':checked'),
       formatter: printDecimal});

    // set office label and bounds
    var officeCurrent = $('#officeCurrent');
    // if no initial value, hide this element
    if (officeValue) {
      officeCurrent.text(officeValue.toFixed());
    } else {
      officeSwitch.bootstrapSwitch('destroy').parent().append(
        '<label>Zur Zeit nicht verfügbar.</label><br>'
      );
      officeCurrent.text('0');
      officeSlide.slider('destroy').parent().hide();
    }
    renderBounds(officeSlide, offices[0], maxoffice);

    // set workshow label and bounds
    var workshopCurrent = $('#workshopCurrent');
    // if no initial value, hide this element
    if (workshopValue) {
      workshopCurrent.text(workshopValue.toFixed());
    } else {
      workshopSwitch.bootstrapSwitch('destroy').parent().append(
        '<label>Zur Zeit nicht verfügbar.</label><br>'
      );
      workshopCurrent.text('0');
      workshopSlide.slider('destroy').parent().hide();
    }
    renderBounds(workshopSlide, workshops[0], maxworkshops);

    // set storage label and bounds
    var storageCurrent = $('#storageCurrent');
    // if no initial value, hide this element
    if (storageValue) {
      storageCurrent.text(storageValue.toFixed());
    } else {
      storageSwitch.bootstrapSwitch('destroy').parent().append(
        '<label>Zur Zeit nicht verfügbar.</label><br>'
      );
      storageCurrent.text('0');
      storageSlide.slider('destroy').parent().hide();
    }
    renderBounds(storageSlide, storages[0], maxstorages);

    // event listeners
    // office
    officeSlide.on('slide', e => {
      officeCurrent.text(e.value);
    }).on('slideStop', e => {
      model.officeArea(e.value);
      model.refresh();
    });
    officeSwitch.on('switchChange.bootstrapSwitch', function(event, stat) {
      model.officeStatus(stat);
      if (stat) {
        $('#office').slider('enable');
        model.officeArea(
          $('#office').slider('getValue'));
        model.refresh();
      } else {
        $('#office').slider('disable');
      }
    });

    // workshow
    workshopSlide.on('slide', e => {
      workshopCurrent.text(e.value);
    }).on('slideStop', e => {
      model.workshopArea(e.value);
      model.refresh();
    });
    workshopSwitch.on('switchChange.bootstrapSwitch', function(event, stat) {
      model.workshopStatus(stat);
      if (stat) {
        $('#workshop').slider('enable');
        model.workshopArea(
          $('#workshop').slider('getValue'));
        model.refresh();
      } else {
        $('#workshop').slider('disable');
      }
    });

    // storage
    storageSlide.on('slide', e => {
      storageCurrent.text(e.value);
    }).on('slideStop', e => {
      model.storageArea(e.value);
      model.refresh();
    });
    storageSwitch.on('switchChange.bootstrapSwitch', function(event, stat) {
      model.storageStatus(stat);
      if (stat) {
        $('#storage').slider('enable');
        model.storageArea(
          $('#storage').slider('getValue'));
        model.refresh();
      } else {
        $('#storage').slider('disable');
      }
    });

    // reoder loaded data
    var locations = {};
    // put building types inside the locations
    $.each(data, (key, obj) => {
      $.each(obj.locations, (i, obj) => {
        let builds = {
          id: key,
          typ: types[key],
          buildings: obj.buildings
        };
        if (!locations[obj.id]) {
          locations[obj.id] = obj;
          locations[obj.id].buildings = [];
        }
        locations[obj.id].shown = true;
        locations[obj.id].buildings.push(builds);
      });
    });

    // load model
    model = new LocationsModel(
      $.map(locations, v => v)
    );
    // init knockout
    ko.applyBindings(model);
    model.officeStatus(officeSwitch.is(':checked'));
    model.workshopStatus(workshopSwitch.is(':checked'));
    model.storageStatus(storageSwitch.is(':checked'));

    var hidebutton = function(callback) {
      $('.loading-button').removeClass('hide');
      $('.loading-button').show();
      setTimeout(() => {
        if (callback) {
          callback();
        }
        $('.loading-button').fadeOut();
      }, 200);
    };

    var refeshlist = function() {
      $('.listing').hide();
      hidebutton(() => $('.listing').show());
    };

    var refreshModel = () => {
      model.officeArea(
          $('#office').slider('getValue'));
      model.workshopArea(
          $('#workshop').slider('getValue'));
      model.storageArea(
          $('#storage').slider('getValue'));
      model.refresh();
    };

    $('.submit').on('click', (e => {
      e.preventDefault();
      refreshModel();
      resultContainer.trigger('listing.refresh');
    }));

    resultContainer.on('listing.refresh', refeshlist);

    router.on('/embed',
      () => {
        model.sliderValues.subscribe(sliders => {
          $.each(sliders, (i, s) => {
            localStorage.setItem(types[i], s);
          });
        });
        resultContainer.off('listing.refresh').hide();
        // $('.submit').off('click');
        $('.submit').on('click', e => {
          e.preventDefault();
          if (window.top) {
            window.top.location.href = embedRedirect;
          }
        });
      });

    router.on('/reactive',
      () => {
        refreshModel();
        resultContainer.on('listing.refresh', refeshlist);
        resultContainer.trigger('listing.refresh');
      });
    router.init();
  });
})(jQuery);
